import React from "react";
import { Translate } from "react-redux-i18n";
import UserDecorator from "../../containers/UserDecorator";
import CircleMember from "../../components/CircleMember";
import { fetchCircle, deleteCircleMembership } from "../../store/my_circles/operations";
import { useDispatch } from 'react-redux';

const CircleMembers = ({ circle, isSuperUser, locale, onMessageClick, myGuid, }) => {
  const dispatch = useDispatch();
  const takeAction = (action, user) => {
    switch (action) {
      case "make_admin":
        console.log("make admin", user);
        break;
      case "kick_user":
        console.log("kick user", user.guid);
        const payload = {
          circle_guid: circle.guid,
          member_guid: user.guid
        }
        dispatch(deleteCircleMembership(payload, fetchCircle(circle.guid, true)));
        break;
      default:

    }
  }

  return (
    <div className="custom-card">
      <h1 className="bp3-heading">
        <Translate value="circle_members.heading" />
      </h1>
      <div className="user-list">
        {circle.members.map((member_id, index) => (
          <UserDecorator userId={member_id} key={member_id}>
            <CircleMember
              isSuperUser={isSuperUser}
              showUserActions={isSuperUser}
              locale={locale}
              onMessageClick={onMessageClick}
              myGuid={myGuid}
              takeAction={takeAction}
            />
          </UserDecorator>
        ))}
      </div>
    </div>
  );
};

export default CircleMembers;
